<section class="ppp-bonuses">
  <header class="ppp-bonuses__header">
    <div>
      <h1>Load bonuses</h1>
      <p class="ppp-bonuses__subtitle">Per-load bonuses earned this week (positional + floor top-ups).</p>
    </div>
  </header>

  <form [formGroup]="form" class="ppp-bonuses__filters">
    <mat-form-field appearance="outline">
      <mat-label>Week start (Monday)</mat-label>
      <input
        matInput
        [matDatepicker]="weekStartPicker"
        [matDatepickerFilter]="mondayDateFilter"
        formControlName="weekStart"
        readonly
      />
      <mat-datepicker-toggle matSuffix [for]="weekStartPicker"></mat-datepicker-toggle>
      <mat-datepicker #weekStartPicker startView="month"></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Bonus type</mat-label>
      <mat-select formControlName="bonusType">
        <mat-option value="all">All</mat-option>
        <mat-option value="positional">Positional</mat-option>
        <mat-option value="floor_topup">Floor top-up</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Region</mat-label>
      <mat-select formControlName="regionId">
        <mat-option [value]="null">All regions</mat-option>
        <mat-option *ngFor="let region of regions$ | async" [value]="region.regionId">
          {{ region.regionName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <ng-container *ngIf="response$ | async as response">
    <div class="ppp-bonuses__totals">
      <div>
        <span class="ppp-bonuses__total-value">{{ response.totals.netActiveCents | centsToDollars }}</span>
        <span class="ppp-bonuses__total-label">Net active</span>
      </div>
      <div>
        <span class="ppp-bonuses__total-value">{{ response.totals.positionalCents | centsToDollars }}</span>
        <span class="ppp-bonuses__total-label">Positional</span>
      </div>
      <div>
        <span class="ppp-bonuses__total-value">{{ response.totals.floorTopupCents | centsToDollars }}</span>
        <span class="ppp-bonuses__total-label">Floor top-ups</span>
      </div>
      <div>
        <span class="ppp-bonuses__total-value">{{ response.totals.archivedCents | centsToDollars }}</span>
        <span class="ppp-bonuses__total-label">Archived</span>
      </div>
    </div>

    <p *ngIf="loading$$ | async" class="ppp-bonuses__hint">Loading bonuses…</p>
    <p *ngIf="error$$ | async as err" class="ppp-bonuses__error">{{ err }}</p>

    <div class="ppp-bonuses__table-wrapper" *ngIf="response.loadBonuses.length > 0; else emptyTpl">
      <table mat-table [dataSource]="response.loadBonuses" class="ppp-bonuses__table">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let b">{{ b.createdAt | date: 'short' }}</td>
        </ng-container>

        <ng-container matColumnDef="driver">
          <th mat-header-cell *matHeaderCellDef>Driver</th>
          <td mat-cell *matCellDef="let b">
            <div>{{ b.driverName }}</div>
            <div class="ppp-bonuses__sub">#{{ b.driverId }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="order">
          <th mat-header-cell *matHeaderCellDef>Order</th>
          <td mat-cell *matCellDef="let b">{{ b.orderId }}</td>
        </ng-container>

        <ng-container matColumnDef="shift">
          <th mat-header-cell *matHeaderCellDef>Shift</th>
          <td mat-cell *matCellDef="let b">{{ b.shiftId }}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let b">
            <span class="ppp-bonuses__type" [class.ppp-bonuses__type--floor]="b.bonusType === 'floor_topup'">
              {{ b.bonusType === 'floor_topup' ? 'Floor top-up' : 'Positional' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef>Position</th>
          <td mat-cell *matCellDef="let b">{{ b.loadPosition || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="bonus">
          <th mat-header-cell *matHeaderCellDef>Bonus</th>
          <td mat-cell *matCellDef="let b">
            <span [class.ppp-bonuses__archived-cell]="b.archivedAt">{{ b.bonusCents | centsToDollars }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['date', 'driver', 'order', 'shift', 'type', 'position', 'bonus']"></tr>
        <tr
          mat-row
          *matRowDef="
            let b;
            columns: ['date', 'driver', 'order', 'shift', 'type', 'position', 'bonus'];
            trackBy: trackByBonus
          "
          class="ppp-bonuses__row"
          [class.ppp-bonuses__row--archived]="b.archivedAt"
          [matTooltip]="b.archivedReason || ''"
        ></tr>
      </table>

      <mat-paginator
        [length]="response.total"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex$$.value"
        (page)="onPageChange($event)"
        showFirstLastButtons
      ></mat-paginator>
    </div>

    <ng-template #emptyTpl>
      <p class="ppp-bonuses__empty">No bonuses match the current filters.</p>
    </ng-template>
  </ng-container>
</section>
